import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ICommentsDatasource } from '../../../../comments/datasources/comments_datasource';

export type ILoadCommentCommand = (url: string) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadCommentCommand',
    function loadCommentCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngCommentsDatasource: ICommentsDatasource,
      log: any
    ) {
      return defineCommandORM('loadCommentCommand', function loadCommentCommand(deferred, url: string) {
        $http
          .get(url)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngCommentsDatasource.clear().write(data);
            deferred.resolve();
          })
          .catch((e: ng.IHttpPromiseCallbackArg<any>) => {
            log.issue('failed to load comments');
            deferred.reject(e.data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_flag_dialog/commands/load_course_flag_command.ts